module.exports = __webpack_public_path__ + "static/img/date-title.6229f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/date-title.png
// module id = p6cW
// module chunks = 126